import { initialState } from '@ispm-client/modules/bpmn-modeler/store/state';
import {
  ContextActionTypes,
  ModelerContextActions
} from "@ispm-client/modules/bpmn-modeler/store/actions/modeler-context.action";

export function modelerContext(state = initialState.modelerContext, action: ModelerContextActions): object {
  switch (action.type) {
    case ContextActionTypes.MODELER_CONTEXT: {
      return action.payload.modelerContext;
    }
    default: {
      return state;
    }
  }
}
